import React, { PureComponent } from 'react';
import ShowForPermission from '../../../components/ShowForPermission';
import styles from '../styles.scss';
import ENUMS from '../../../enums';

class ListItem extends PureComponent {
  render() {
    const { id, pageNumber, pageSize, ix, imageUrl, displayOrder, isVisible, isDefault } = this.props;

    return (
      <tr key={id}>
        <td className="text-center">{(pageNumber - 1) * pageSize + ix + 1}</td>
        <td>
          <img src={imageUrl} className={styles.adImageListItem} />
        </td>
        <td className="text-center">{displayOrder}</td>
        <td className="text-center">
          <ShowForPermission permission={ENUMS.PERMISSIONS.values.UPDATE_IS_VISIBLE_AD}>
            {isVisible === true ? (
              <span className="text-success">{locales('labels.visible')}</span>
            ) : (
              <span className="text-muted">{locales('labels.invisible')}</span>
            )}
          </ShowForPermission>
        </td>
        <td className="d-flex flex-column justify-space-around">
          {isDefault === false ? (
            <a className="btn btn-primary btn-sm my-1" onClick={e => this.props.defaultAd(id, true)}>
              {locales('labels.defaultAd')}
            </a>
          ) : (
            <a className="btn btn-danger btn-sm  my-1" onClick={e => this.props.defaultAd(id, false)}>
              {locales('labels.undefaultAd')}
            </a>
          )}
          {isVisible === true ? (
            <a className="btn btn-warning btn-sm  my-1" onClick={e => this.props.invisibleAd(id)}>
              {locales('labels.make.invisible')}
            </a>
          ) : (
            <a className="btn btn-success btn-sm  my-1" onClick={e => this.props.visibleAd(id)}>
              {locales('labels.make.visible')}
            </a>
          )}
          <ShowForPermission permission={ENUMS.PERMISSIONS.values.DELETE_AD}>
            <a className="btn btn-danger btn-sm  my-1" onClick={e => this.props.deleteAd(id)}>
              <i className="far fa-trash" />
              {locales('labels.delete')}
            </a>
          </ShowForPermission>
        </td>
      </tr>
    );
  }
}

export default ListItem;
